import { useQuery, gql, useLazyQuery } from '@apollo/client';
import {
  ProjetoProfessoresQuery,
  ProjetoProfessoresQueryVariables,
} from './__generated__/ProjetoProfessoresQuery';

const PROFESSORES_QUERY = gql`
  query ProjetoProfessoresQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    professores(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_professor
      dsc_nome_professor
    }
  }
`;

const useProfessoresQuery = (variables: ProjetoProfessoresQueryVariables) => {
  return useQuery<ProjetoProfessoresQuery, ProjetoProfessoresQueryVariables>(PROFESSORES_QUERY, {
    variables,
  });
};

const useProfessoresLazyQuery = () => {
  return useLazyQuery<ProjetoProfessoresQuery, ProjetoProfessoresQueryVariables>(PROFESSORES_QUERY);
};

export { useProfessoresQuery, useProfessoresLazyQuery };
